import _ from 'lodash';
import { VCHIP_RATINGS } from 'helpers/auth.clientless';

const MPAA_RATINGS = ['g', 'pg', 'pg-13', 'r', 'nc-17'];

function checkParentalControls(account, contentRating, pcs) {
  let videoAllowed = true;

  if (!account || !pcs || !contentRating) return videoAllowed;

  const { tv_rating_val, mv_rating_val } = pcs;

  const lowercaseContentRating = _.toLower(contentRating);

  const videoTvIndex = _.findIndex(VCHIP_RATINGS, r => r === lowercaseContentRating);

  const videoMovieIndex = _.findIndex(MPAA_RATINGS, r => r === lowercaseContentRating);

  if (videoTvIndex > -1) {
    const userTvIndex = _.findIndex(VCHIP_RATINGS, r => r === _.toLower(tv_rating_val));
    if (userTvIndex < videoTvIndex) videoAllowed = false;
  } else if (videoMovieIndex > -1) {
    const userMovieIndex = _.findIndex(MPAA_RATINGS, r => r === _.toLower(mv_rating_val));
    if (userMovieIndex < videoMovieIndex) videoAllowed = false;
  }

  return videoAllowed;
}

export default checkParentalControls;
